import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';

const Logout: React.FC = () => {
  const { authToken, setIsAuthenticated, setAuthToken } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    // In a real application, you might want to invalidate the token on the backend.
    setAuthToken(null);
//   setIsAuthenticated(false);
    navigate('/login');
    console.log('Logged out');
  };

  handleLogout();

  return (
    <div className="container mt-5">
        <p>Logging out ......</p>
    </div>
  );
};

export default Logout;